export const Logo = () => {
  return <span
      className="brand-text font-weight-light">CFLOW</span>
}
